<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <img :src="imagePath+banner" width="100%" alt="">
    <!-- 电脑导航 -->
    <div class="header-nav hidden-xs">
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper container">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index == navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link v-if="item.is_url == 2" :to="item.path" class="text-decoration-none text-white">
            {{ item.name }}
<!--            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>-->
            <i class="underline"></i>
          </router-link>
          <a v-else :href="item.path" class="text-decoration-none text-white">
            {{ item.name }}
            <i class="underline"></i>
          </a>
<!--          <dl v-if="item.children.length>0">-->
<!--            <dt v-for="(i,n) in item.children" :key="n">-->
<!--              <router-link :to="i.path">{{ i.name }}</router-link>-->
<!--            </dt>-->
<!--          </dl>-->
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { getMenuData } from "../api/home";
import serverConfig from "../http/config";
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [],
      banner: '',
      imagePath: serverConfig.imageURL
    };
  },
  created() {
    this.getMenuData();
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
      this.navList.forEach(function (k,v){
        if (v.name === name) {
          this.banner = v.image
        }
      })
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    async getMenuData() {
      const { data } = await getMenuData({});
      this.navList = data;
      this.banner = data[0].image
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  background: #0D55E8;
  height: 40px;
}
/* 导航栏 导航容器 */
#header .header-nav .header-nav-wrapper {
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  margin: 0 15px;
  position: relative;
}
@media screen and (max-width: 997px) {
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue